<!-- <ngx-loading-bar [includeSpinner]="false" color="#4800F7"></ngx-loading-bar> txt t-->
<div *ngIf="isLoggedIn && !wmsEnabled" class="wms-integration-banner">
    <span translate
        >Warehouse is not connected to this account. Please contact the
        Administrator/Account Manager.</span
    >
</div>
<router-outlet></router-outlet>
<lib-anc-viewport-notice></lib-anc-viewport-notice>
<app-cookie-consent-modal
    [includeChurnZero]="true"
    [includeMixpanel]="true"
    [includeProductFruits]="true"
></app-cookie-consent-modal>
